import { ObjectiveTrackedMetric } from 'graphql/types';

export const trackedMetricLabels = new Map<ObjectiveTrackedMetric, string>([
  ['WEIGHT_KG', 'Weight (KG)'],
]);
